// TODO: Moce to ui-kit
import { contentType } from 'mime-types'
import type { ComponentProps } from 'react'
import { Icon } from '~/elements'
import { P, match } from 'ts-pattern'
import { CameraIcon, FileTextIcon, ImageIcon, Volume2Icon } from 'lucide-react'

type Props = { className?: string; type: string } & Omit<ComponentProps<typeof Icon>, 'icon' | 'color'>

export const FileIcon = ({ type, ...props }: Props) => {
  const mimeType = contentType(type)

  const iconProps = match(mimeType)
    .with(P.string.startsWith('image/'), () => ({ color: 'blue', icon: ImageIcon }) as const)
    .with(P.string.startsWith('video/'), () => ({ color: 'purple', icon: CameraIcon }) as const)
    .with(P.string.startsWith('audio/'), () => ({ color: 'orange', icon: Volume2Icon }) as const)
    .otherwise(() => ({ color: 'amber', icon: FileTextIcon }) as const)

  return <Icon {...iconProps} {...props} />
}
